import { render } from "./WebsiteVisits.vue?vue&type=template&id=2183fd38"
import script from "./WebsiteVisits.vue?vue&type=script&lang=js"
export * from "./WebsiteVisits.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__